import type cytoscape from 'cytoscape'

import type { Feature } from '../../feature'
import type * as models from '../../models'

/**
 * Allows the user to move nodes around and to drag them on top of each other to
 * reassign them
 */
export function setupDragAndDrop(
  cy: cytoscape.Core,
  { feature, orgChartId }: setupDragAndDrop.AdditionalParams,
) {
  cy.nodes().grabify()

  cy.on('dragfree', 'node', event => {
    const droppedNode = event.target as cytoscape.NodeSingular

    const droppedNodeBounds = droppedNode.boundingBox()

    cy.nodes()
      .not(droppedNode)
      .forEach(otherNode => {
        const otherNodeBounds = otherNode.boundingBox()

        // Check for intersection
        if (
          droppedNodeBounds.x1 < otherNodeBounds.x2 &&
          droppedNodeBounds.x2 > otherNodeBounds.x1 &&
          droppedNodeBounds.y1 < otherNodeBounds.y2 &&
          droppedNodeBounds.y2 > otherNodeBounds.y1
        ) {
          feature.actions.assign.from('Cytoscape.Node.Dragfree').dispatch({
            edge: {
              childId: droppedNode.id(),
              parentId: otherNode.id(),
            },
            orgChartId,
          })
        }
      })
  })
}
export namespace setupDragAndDrop {
  export interface AdditionalParams extends models.OrgChart.Identifier {
    readonly feature: Feature
  }
}
